import axios from 'axios'
import Vue from 'vue'
import { getSavedState, saveState } from '../store/helpers'
import _ from 'lodash'
import { v4 as uuidV4 } from 'uuid'

const {
	VUE_APP_NAME,
	VUE_APP_VERSION,
	VUE_APP_SG_API_URL,
	VUE_APP_BR_API_URL
} = process.env

/**
 * @returns {string}
 */
const getBaseURL = () => {
	const currentDataCenter = getSavedState('config.dc') || 'sg'
	return currentDataCenter === 'sg' ? VUE_APP_SG_API_URL : VUE_APP_BR_API_URL
}

/**
 *
 * @param {'sg' | 'br'} dataCenter
 */
export function reloadPageOnBaseURLChange(dataCenter = 'sg') {
	const currentBaseURL =
		dataCenter === 'sg' ? VUE_APP_SG_API_URL : VUE_APP_BR_API_URL

	if (currentBaseURL !== axiosApiClient.defaults.baseURL) {
		saveState('config.dc', dataCenter)
		window.location.reload()
	}
}

const axiosApiClient = axios.create({
	baseURL: getBaseURL(),
	headers: {
		common: {
			'X-LLM-APPNAME': VUE_APP_NAME,
			'X-LLM-VERSION': VUE_APP_VERSION
		}
	},
	timeout: 30000
})

axiosApiClient.interceptors.request.use(request => {
	const authToken = `Bearer ${Vue.$cookies.get('auth_token')}`
	return {
		...request,
		headers: {
			...(request.headers || {}),
			'X-Request-Id': uuidV4(),
			Authorization: authToken
		}
	}
})

export default axiosApiClient
